import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: "#556cd6",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
    loadmore: {
      main: "#221f1fde",
      contrastText: "#fff",
    },
    button: {
      main: "#0000001f",
      contrastText: "#382f2fde",
    },
  },
  typography: {
    htmlFontSize: 10,
  },
});

export default theme;
